function toggleTabs (el) {

    const tabs = [...el.querySelectorAll('.tabbed-title')]
	var activeTab = el.querySelector('.tabbed-title.active')

	const content = el.querySelectorAll('.tabbed-content')
	var activeContent = el.querySelector('.tabbed-content.active')

	function clickHandler(event) {
        
        const tab = event.currentTarget
		var tabID = tab.getAttribute('data-tabbed-trigger') || ''
		content.forEach(item => {
			var contentID = item.getAttribute('data-tabbed-content') || ''
			if (contentID === tabID) {
                removeClasses()

                activeTab = tab
                tab.classList.add('active')

				activeContent = item
				item.classList.add('active')
			}
		})
	}
	
	function removeClasses() {
		activeTab && activeTab.classList.remove('active')
		activeContent && activeContent.classList.remove('active')
	}

	tabs.forEach(function(tab) {
		tab.addEventListener('click', clickHandler)
	})
}

export default function init() {
	[...document.querySelectorAll('.tabbed')].map(toggleTabs)
}
